import { EntityContentBlueprint } from "@backstage/plugin-catalog-react/alpha"
import { createFrontendModule } from "@backstage/frontend-plugin-api"
import { compatWrapper } from "@backstage/core-compat-api"

const changelogContent = EntityContentBlueprint.make({
  name: "changelog",
  params: {
    path: "changelog",
    title: "Changelog",
    filter: "kind:component",
    loader: () => import("./ChangelogPage").then((m) => compatWrapper(<m.ChangelogPage />)),
  },
})

export const changelogModule = createFrontendModule({
  pluginId: "catalog",
  extensions: [changelogContent],
})
